import React from "react";
import { Modal, DeleteDialog } from "../../../components";
import FileUploadModal from "../files/fileuploadmodal";
import GeneralFlightDetail from "../flightdetails/generalflightdetail";
import SegmentList from "../segmentdetail/flightsegmentlist";
import RetrieveFlights from "../retrieveflights/retrieveflights";
import DetailViewPanel from "components/panels/DetailViewPanel";
import { ButtonSecondary } from "components/Atoms/Button";
import { type UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";

interface Props {
  initialFlight: server.dto.Flight
}

interface State {
  showFileUpload: boolean
  flight: server.dto.Flight
  deletingSegmentId: number | undefined
  showFlightlookup: boolean
}

export default class FlightDetailOutsideModal extends React.Component<Props, State> {
  state: State = {
    showFileUpload: false,
    flight: this.props.initialFlight,
    deletingSegmentId: undefined,
    showFlightlookup: false
  };

  onFilesAddClick = () => {
    this.setState({ showFileUpload: true });
  };

  onFilesUploaded = async () => {
    const result = await window.Api.Flights.GetFlight(this.state.flight.id);
    this.setState({ flight: result.data });
  };

  onSegmentDeleteClick = (segment: server.dto.FlightSegment) => {
    this.setState({ deletingSegmentId: segment.id });
  };

  deleteSelectedSegment = async () => {
    await window.Api.Flights.DeleteSegment(this.state.deletingSegmentId);

    this.setState({ deletingSegmentId: undefined });
    window.location.reload();
  };

  uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.File.UploadFlightFiles,
      window.CoreApi.File.UploadFlightFiles.absoluteUrl(),
      {
        files,
        flightId: this.state.flight.id
      },
      uploadConfig
    );
  };

  public render() {
    const headerButton = this.state.flight.permissions.canModify
      ? <ButtonSecondary onClick={() => { this.setState({ showFlightlookup: true }); }} label={RESX.Flight.AddSegment} />
      : null;

    return <>
      <DetailViewPanel
        title={RESX.Flight.resxFlight}
        headerChildren={headerButton}
      >
        <div className="flex-column gap-bigger">
          <GeneralFlightDetail
            flight={this.state.flight}
            onFilesAddClick={this.onFilesAddClick}
            onFlightEditClicked={() => SystemOneLibrary.exports.editFlight(this.state.flight.id)}
          />
          <SegmentList
            flight={this.state.flight}
            segments={this.state.flight.segments}
            connectionTimes={this.state.flight.connectionTimes}
            onSegmentEdit={(seg) => SystemOneLibrary.exports.editSegment(seg.id)}
            onSegmentDelete={this.onSegmentDeleteClick}
          />
        </div>
      </DetailViewPanel>

      <Modal
        title={RESX.File.Files}
        isOpen={this.state.showFileUpload}
        width={"small"}
        minHeight={400}
        height={750}
        handleClose={() => { this.setState({ showFileUpload: false }); }}
      >
        <FileUploadModal
          canEdit={this.state.flight.permissions.canModify}
          files={this.state.flight.files}
          onFilesChanged={this.onFilesUploaded}
          upload={this.uploadFiles}
          deleteEndpoint={window.CoreApi.File.DeleteFlightFile}
          renameEndpoint={window.CoreApi.File.SetFlightFileProperties}
        />
      </Modal>

      <Modal
        title={RESX.Flight.FlightLookup}
        isOpen={this.state.showFlightlookup}
        width={"large"}
        minHeight={450}
        height={600}
        handleClose={() => { this.setState({ showFlightlookup: false }); }}
      >
        <RetrieveFlights
          onManualEntryClicked={() => {
            SystemOneLibrary.exports.manualFlightEntry(this.state.flight.id);
            this.setState({ showFlightlookup: false });
          }}
          onSelectWithSegmentClicked={(segments) => {
            SystemOneLibrary.exports.existingSegmentsAdded(this.state.flight.id, segments);
            this.setState({ showFlightlookup: false });
          }}
        />
      </Modal>

      <DeleteDialog
        isOpen={!!this.state.deletingSegmentId}
        message={RESX.GeneralWarnings.AreYouSure}
        handleClose={() => { this.setState({ deletingSegmentId: undefined }); }}
        onDelete={this.deleteSelectedSegment} />
    </>;
  }
}
